import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'app/shared/components/button/button.module';
import { InputBoxModule } from 'app/shared/components/input-box/input-box.module';
import { ModalModule } from 'app/shared/components/modal/modal.module';
import { SaveFilterFormComponent } from './save-filter-form.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputBoxModule,
    ButtonModule,
    ModalModule,
  ],
  declarations: [SaveFilterFormComponent],
  exports: [SaveFilterFormComponent],
})
export class SaveFilterFormModule {}
